import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { Booking } from '../../../../entities/booking';

@Component({
    selector: 'page-cancel-booking',
    templateUrl: 'cancel-booking.html',
})
export class CancelBookingPage {

    booking: Booking;

    constructor(
        private navParams: NavParams,
    ) {
        this.booking = this.navParams.get('booking');
    }
}



// WEBPACK FOOTER //
// ./src/pages/bookings/my-bookings/cancel-booking/cancel-booking.ts